import clsx from 'clsx';
import type { FC, Ref } from 'react';

import { Typography } from '@/components/shared/Typography';

import css from './style.module.scss';

export interface SliderNavButtonsProps {
	ref?: Ref<HTMLDivElement>;
	onPrevious: () => void;
	onNext: () => void;
	className?: string;
	previousLabel?: string;
	nextLabel?: string;
	previousDisabled?: boolean;
	nextDisabled?: boolean;
}

const SliderNavButtons: FC<SliderNavButtonsProps> = ({
	ref,
	onPrevious,
	onNext,
	className,
	previousLabel = '‹ Previous',
	nextLabel = 'Next ›',
	previousDisabled = false,
	nextDisabled = false
}) => (
	<div ref={ref} className={clsx(css.navigation, className)}>
		<button
			type="button"
			className={css.navButton}
			aria-label="Previous slide"
			disabled={previousDisabled}
			onClick={onPrevious}
		>
			<Typography variant="body-l" tag="span">
				{previousLabel}
			</Typography>
		</button>
		<button
			type="button"
			className={css.navButton}
			aria-label="Next slide"
			disabled={nextDisabled}
			onClick={onNext}
		>
			<Typography variant="body-l" tag="span">
				{nextLabel}
			</Typography>
		</button>
	</div>
);

export default SliderNavButtons;
